export class Average {
    values: string[];
    value: string;
    average2dec: string;
    average1dec: string;
    index: number;
    valid: boolean;
    message: string;
}